module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"undefinedProduct":"Loading information..."},"es":{"undefinedProduct":"Cargando información..."}}')
  delete Component.options._Ctor
}
